import React, { useCallback, useContext } from "react";
import { CareRecipient } from "../../../../../domain/care_recipient/CareRecipient";
import { User } from "../../../../../domain/user/User";
import { Paths } from "../../../../../Paths";
import { useAppDispatch } from "../../../../../state/store";
import { deleteCareRecipientAction } from "../../../../../state/usecase/admin/care_recipient/actions";
import { deleteUserAction } from "../../../../../state/usecase/admin/user/actions";
import { useAuthUser } from "../../../../hooks/auth/useAuthUser";
import { AdminListContext } from "../../../../provider/AdminListProvider";
import { AddButton } from "../../../common/button/AddButton";
import { Loading } from "../../../common/Loading";
import { NoData } from "../../../common/no_data/NoData";
import { AdminListTableRow } from "./AdminListTableRow";
import { useNavigate } from "react-router-dom";

export const AdminListTableBody = React.memo(function AdminListTableBody() {
    const {
        displayList
    } = useContext(AdminListContext);

    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    const authUser = useAuthUser();

    const handleCareRecipientEditClick = useCallback((careRecipient: CareRecipient) => () => {
        navigate(`${Paths.admin}${Paths.careRecipient}${Paths.edit}/${careRecipient.id.value}`);
    }, [navigate]);

    const handleUserEditClick = useCallback((user: User) => () => {
        navigate(`${Paths.admin}${Paths.user}${Paths.edit}/${user.id.value}`);
    }, [navigate]);

    const handleUserDeleteClick = useCallback((user: User) => () => {
        if (user.id.value === authUser.id.value) {
            alert("自分自身のアカウントは削除できません。");
            return;
        }

        if (!window.confirm(`${user.name.value}を削除しますか？`)) return;

        dispatch(
            deleteUserAction({
                userId: user.id
            })
        );
    }, [dispatch]);

    const handleCareRecipientDeleteClick = useCallback((careRecipient: CareRecipient) => () => {
        if (!window.confirm(`${careRecipient.name.value}を削除しますか？`)) return;

        dispatch(
            deleteCareRecipientAction({
                careRecipientId: careRecipient.id
            })
        );
    }, [dispatch]);

    const handleCareRecipientAddClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.careRecipient}${Paths.add}`);
    }, [navigate]);

    const handleUserAddClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.user}${Paths.add}`);
    }, [navigate]);

    return (
        <tbody>
            <tr>
                <td colSpan={6}>
                    <AddButton label={"利用者を追加する"} onClick={handleCareRecipientAddClicked} />
                </td>
                <td colSpan={4}>
                    <AddButton label={"ユーザーを追加する"} onClick={handleUserAddClicked} />
                </td>
            </tr>
            {!displayList ? (
                <tr>
                    <td colSpan={10}>
                        <Loading />
                    </td>
                </tr>
            ) : !displayList.length ? (
                <tr>
                    <td colSpan={6}>
                        <NoData />
                    </td>
                    <td colSpan={4}>
                        <NoData />
                    </td>
                </tr>
            ) : (
                <>                
                    {displayList.map(item  => (
                        <AdminListTableRow
                            key={item.careRecipientWithDataSyncInfo?.careRecipient?.id.value ?? 1}
                            careRecipientWithDataSyncInfo={item.careRecipientWithDataSyncInfo}
                            users={item.users}
                            handleCareRecipientDeleteClick={handleCareRecipientDeleteClick}
                            handleCareRecipientEditClick={handleCareRecipientEditClick}
                            handleUserDeleteClick={handleUserDeleteClick}
                            handleUserEditClick={handleUserEditClick}
                        />
                    ))}
                </>
            )}
        </tbody>
    );
});
